import { getDie, isValidDieRoll, rollDie } from './dice';

export const STANCES = {
  strike: {
    name: 'Strike',
    symbol: '✦',
    multiplier: 1,
    description: 'Normal die faces and incoming damage.',
  },
  guard: {
    name: 'Guard',
    symbol: '⬡',
    multiplier: 0.75,
    description: 'Each die face is 25% weaker. Block 1 incoming damage.',
  },
  overload: {
    name: 'Overload',
    symbol: 'ϟ',
    multiplier: 1.5,
    description: 'Each die face is 50% stronger. Take 3 extra damage when hit.',
  },
};

export const applyAttackStyle = (value, stance = 'strike') =>
  Math.round(value * (STANCES[stance]?.multiplier || 1));

export const createCoreDieFaces = (dieId, random = Math.random) => [
  ...(getDie(dieId).faces ||
    Array.from({ length: 6 }, () => rollDie(dieId, random))),
];

export const hasCoreAttackStyle = (game) =>
  game.coreStyleVersion === 1 &&
  (game.phase?.startsWith('boss') ||
    (game.lastResult?.boss && ['won', 'lost'].includes(game.phase)));

export const applyCoreAttackStyle = (game, value) =>
  hasCoreAttackStyle(game) ? applyAttackStyle(value, game.stance) : value;

export const getCoreRollCandidates = (game) =>
  (
    getDie(game.selectedDie).faces ||
    Array.from({ length: 100 }, (_, index) => index + 1)
  ).map((value) => applyCoreAttackStyle(game, value));

export const getCoreDieFaceValues = (game) => {
  if (
    game.phase !== 'bossReady' &&
    game.coreDieCurrentFaces?.length === 6 &&
    game.coreDieCurrentFaces.every(
      (value) => Number.isSafeInteger(value) && value >= 0
    )
  )
    return [...game.coreDieCurrentFaces];
  const faces = getDie(game.selectedDie).faces || game.coreDieFaces;
  return faces?.length === 6
    ? faces.map((value) => applyCoreAttackStyle(game, value))
    : null;
};

export const isValidCoreDieRoll = (game, value) =>
  Number.isInteger(value) && getCoreRollCandidates(game).includes(value);

// Finish already-thrown legacy dice as recorded, then use the new styles on
// their next ready turn. Retired burst fields never influence a new attack.
export const migrateCoreAttackStyles = (game) => {
  const { charge, burst, burstCost, ...next } = game;
  if (
    !['bossReady', 'bossPlayerRolled', 'bossRolled', 'bossResult'].includes(
      next.phase
    )
  )
    return next;
  if (next.phase === 'bossReady' || next.phase === 'bossResult')
    next.coreStyleVersion = 1;
  else next.coreStyleVersion = next.coreStyleVersion === 1 ? 1 : 0;
  if (!STANCES[next.stance]) next.stance = 'strike';
  if (
    !Array.isArray(next.coreDieFaces) ||
    next.coreDieFaces.length !== 6 ||
    !next.coreDieFaces.every((value) => isValidDieRoll(value, next.selectedDie))
  )
    next.coreDieFaces = createCoreDieFaces(next.selectedDie);
  return next;
};
